import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackView } from "../lib/api";

function getSid() {
  let s = localStorage.getItem("domaleo_sid");
  if (!s) {
    s = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : String(Date.now()) + Math.random();
    localStorage.setItem("domaleo_sid", s);
  }
  return s;
}

export function Analytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    trackView(pathname, getSid());
  }, [pathname]);
  return null;
}
